/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2023, Zumper
 * @description  logger.ts
 */

import { createLoggerInterface } from '@zcode/logger'

export const { logger, setLogger, setLogLevel } = createLoggerInterface()
